var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal modalShown"},[_c('div',{staticClass:"schemeImg"},[_c('div',{style:({
        'background-image': ("url(" + (require('@/assets/images/CycleRoute/mapOverview.jpg')) + ")"),
      })})])])}
var staticRenderFns = []

export { render, staticRenderFns }